/** @jsxImportSource @emotion/react */
import { css, keyframes } from '@emotion/react';

const WARNING_FROM_SECONDS = 15;
const CRITICAL_FROM_SECONDS = 5;

const NEUTRAL_COLOUR = '#16211f';
const WARNING_COLOUR = '#a35f00';
const CRITICAL_COLOUR = '#c0392b';

const tickPulse = keyframes({
  '0%': { transform: 'scale(1)' },
  '22%': { transform: 'scale(1.22)' },
  '100%': { transform: 'scale(1)' },
});

/**
 * Colour for the seconds remaining, escalating as the countdown runs out.
 *
 * @param {number} seconds - seconds left on the countdown.
 * @returns {string} hex colour.
 */
export const getCountdownColour = (seconds) => {
  if (seconds <= CRITICAL_FROM_SECONDS) return CRITICAL_COLOUR;
  if (seconds <= WARNING_FROM_SECONDS) return WARNING_COLOUR;
  return NEUTRAL_COLOUR;
};

const makeInactivityPromptStyles = () => ({
  box: css({
    position: 'absolute',
    top: 24,
    left: '50%',
    transform: 'translateX(-50%)',
    width: '85%',
    maxWidth: 400,
    padding: 24,
    borderRadius: 8,
    backgroundColor: '#ffffff',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    textAlign: 'center',
  }),
  countdown: css({
    fontSize: 22,
    fontWeight: 400,
    fontVariantNumeric: 'tabular-nums',
    display: 'inline-block',
    transition: 'color 0.4s ease',
    animation: `${tickPulse} 0.42s ease-out`,
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
    },
  }),
  heading: css({
    marginTop: 8,
    '& h6': { fontWeight: 900, fontSize: 22, lineHeight: 1.2 },
  }),
  subheading: css({
    marginTop: 8,
  }),
  confirmButton: css({
    marginTop: 20,
  }),
});

export default makeInactivityPromptStyles;
